import { render, staticRenderFns } from "./BModal.vue?vue&type=template&id=7877d655&scoped=true"
import script from "./BModal.vue?vue&type=script&lang=js"
export * from "./BModal.vue?vue&type=script&lang=js"
import style0 from "./BModal.vue?vue&type=style&index=0&id=7877d655&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7877d655",
  null
  
)

export default component.exports